export default __webpack_public_path__ + "static/media/art-5-spinach.909e32cc.jpg";